import React, {useEffect, useRef} from "react";
import FaqsIntro from "./FaqsIntro";
import VideoCarousel from "../homePage/VideoCarousel";
import FaqQuestionaire from "./FaqQuestionaire";
import { useLocation } from "react-router-dom";

const Faq = () => {
  const videoRef = useRef(null);
  useEffect(() => {
    // Delay to allow React Router to fully update the DOM
    const timer = setTimeout(() => {
      if (window.location.hash === "#videos" && videoRef.current) {
        videoRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // 100ms delay (tweak as needed)

    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (location.hash === "#videos" && videoRef.current) {
        videoRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <FaqsIntro />
      <h2 className="carousel-title mb-3">
        <span
          style={{ borderBottom: "2px solid #0E72D6", paddingBottom: "3px" }}
        >
          {" "}
          Short Videos
        </span>
      </h2>

      <div ref={videoRef} id="videos">
        <VideoCarousel showBlueLine={false} />
      </div>
      <FaqQuestionaire />
    </>
  );
};

export default Faq;
